import { Box, Typography } from '@mui/material';
import { ShieldCheck } from 'lucide-react';
import { useState } from 'react';

import type { FileRejection } from 'react-dropzone';

import { DEFAULT_MAX_FILE_SIZE_BYTES, FilePicker } from '@/components/common/FilePicker';
import { useUploaderContext } from '@/context/UploaderProvider';

export const UploadStep = () => {
  const { startFileUpload } = useUploaderContext();
  const [error, setError] = useState('');

  const handleFiles = (files: File[], rejections: FileRejection[]) => {
    if (rejections.length > 0 || files.length === 0) {
      setError('Please use a PDF, DOCX, JPG, or PNG file under 25MB.');
      return;
    }
    setError('');
    startFileUpload([files[0]]);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          bgcolor: 'var(--tx-fill-2)',
          color: 'var(--tx-text)',
          borderRadius: '5px',
          px: '12px',
          py: '6px',
          mb: '22px',
          alignSelf: 'flex-start',
        }}>
        <ShieldCheck size={14} strokeWidth={2} />
        <Typography sx={{ fontSize: 11, fontWeight: 600, letterSpacing: '.08em' }}>
          INSPECTION REPORT
        </Typography>
      </Box>

      <Typography sx={{ color: 'var(--tx-text)', fontSize: 24, fontWeight: 600, mb: '8px' }}>
        Unlock your Home HQ
      </Typography>
      <Typography sx={{ color: '#918d87', fontSize: 13, lineHeight: 1.65, mb: '20px', maxWidth: 520 }}>
        Turn your inspection report into a clear picture of your home—and a practical plan for what
        comes next.
      </Typography>

      {/* Dropzone fills whatever room the three now-removed feature tiles
          used to take — a bigger, more confident target beats re-explaining
          a promise the user has already seen twice getting here. */}
      <FilePicker
        withDropZone
        highlightOnDrag
        dropZoneBorderRadius="20px"
        maxFileSizeInBytes={DEFAULT_MAX_FILE_SIZE_BYTES}
        onChange={handleFiles}
      />

      {error && <Typography sx={{ color: '#db5282', fontSize: 11, mt: '12px' }}>{error}</Typography>}
      <Typography sx={{ color: '#77736e', fontSize: 10, mt: '12px', textAlign: 'center' }}>
        PDF, DOCX, JPG, or PNG · Maximum 25MB
      </Typography>
    </Box>
  );
};
